import { useState } from "react";
import { registrarJugador } from "../services/api";
import { useNavigate } from "react-router-dom";
import "../styles/registro.css";
import Swal from "sweetalert2";

export default function Registro() {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    password: "",
    confirmPassword: "",
    categoria: "",
    dni: "",
    ciudad: "",
    genero: "",
    celular: ""
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  // Categorías según género
  const categoriasOptions = {
    Libres: ["Suma8", "5ta", "6ta", "7ma", "8va"],
    Damas: ["Suma11", "6ta", "7ma", "8va"],
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");

  // Validación de contraseñas
  if (form.password !== form.confirmPassword) {
    Swal.fire({
      title: "Error",
      text: "Las contraseñas no coinciden",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
    return;
  }

  // Validación de contraseña (mínimo 6 caracteres)
  if (form.password.length < 6) {
    Swal.fire({
      title: "Error",
      text: "La contraseña debe tener al menos 6 caracteres",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
    return;
  }

  // Validación de DNI (solo números y longitud)
  if (form.dni.length < 7 || form.dni.length > 8) {
    Swal.fire({
      title: "Error",
      text: "El DNI debe tener entre 7 y 8 dígitos",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
    return;
  }

  try {
    const response = await registrarJugador(form);
    const esRespuestaApiValida =
      response?.status === 201 &&
      response?.data &&
      typeof response.data === "object" &&
      response.data.mensaje === "Registro exitoso";

    if (!esRespuestaApiValida) {
      throw new Error("Respuesta inesperada del servidor");
    }

    Swal.fire({
      title: "¡Registro exitoso!",
      text: "Redirigiendo al login...",
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then(() => {
      navigate("/login");
    });
  } catch (err) {
    // Manejo de errores específicos
    if (err.response) {
      const rawError = err.response?.data?.message ?? err.response?.data?.error;
      const errorMessage =
        typeof rawError === "string"
          ? rawError
          : rawError?.sqlMessage || rawError?.message || "Error al registrar";
      const normalizedError = errorMessage.toLowerCase();

      if (normalizedError.includes("dni")) {
        Swal.fire({
          title: "Error",
          text: "El DNI ya está registrado. Por favor, verifica tus datos.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } else if (normalizedError.includes("email") || normalizedError.includes("correo")) {
        Swal.fire({
          title: "Error",
          text: "El email ya está registrado. Por favor, usa otro correo.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } else if (normalizedError.includes("contraseña") || normalizedError.includes("password")) {
        Swal.fire({
          title: "Error",
          text: "La contraseña no cumple con los requisitos. Intenta con otra.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: errorMessage || "Error al registrar. Verifica los datos e intenta más tarde.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    } else {
      Swal.fire({
        title: "Error",
        text: "La API no respondió correctamente. Verifica la URL del backend y vuelve a intentar.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
    console.error(err);
  }
};

  return (
    <div className="registro-container">
      <form className="registro-form" onSubmit={handleSubmit}>
        <h2>Registro</h2>
        
        {error && (
          <div style={{ 
            color: "white", 
            backgroundColor: "#dc3545", 
            padding: "10px", 
            borderRadius: "5px",
            marginBottom: "15px",
            textAlign: "center" 
          }}>
            {error}
          </div>
        )}
        
        {success && (
          <div style={{ 
            color: "white", 
            backgroundColor: "#28a745", 
            padding: "10px", 
            borderRadius: "5px",
            marginBottom: "15px",
            textAlign: "center" 
          }}>
            {success}
          </div>
        )}

        <div className="registro-row">
          <label>Apellido y Nombre</label>
          <input 
            placeholder="Apellido y Nombre" 
            value={form.nombre}
            onChange={e => setForm({ ...form, nombre: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>DNI</label>
          <input 
            placeholder="DNI" 
            type="number" 
            value={form.dni}
            onChange={e => setForm({ ...form, dni: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Ciudad</label>
          <input 
            placeholder="Ciudad" 
            value={form.ciudad}
            onChange={e => setForm({ ...form, ciudad: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Correo Electrónico</label>
          <input 
            placeholder="Email" 
            type="email" 
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Celular</label>
          <input 
            placeholder="Celular" 
            type="tel" 
            value={form.celular}
            onChange={e => setForm({ ...form, celular: e.target.value })} 
            required 
          />
        </div>

        <div className="registro-row">
          <label>Contraseña</label>
          <input 
            type="password" 
            placeholder="Contraseña (mínimo 6 caracteres)" 
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Confirmar Contraseña</label>
          <input 
            type="password" 
            placeholder="Confirmar contraseña" 
            value={form.confirmPassword}
            onChange={e => setForm({ ...form, confirmPassword: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Género</label>
          <select 
            value={form.genero}
            onChange={e => setForm({ ...form, genero: e.target.value, categoria: "" })} 
            required
          >
            <option value="">Selecciona género</option>
            <option value="Libres">Caballeros (Libres)</option>
            <option value="Damas">Damas</option>
          </select>
        </div>
        <div className="registro-row">
          <label>Categoría</label>
          <select 
            value={form.categoria}
            onChange={e => setForm({ ...form, categoria: e.target.value })} 
            required
            disabled={!form.genero}
          >
            <option value="">Selecciona categoría</option>
            {form.genero && categoriasOptions[form.genero]?.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
        <button type="submit">Registrarse</button>
        <button type="button" onClick={() => navigate("/")}>Volver al inicio</button>
      </form>
    </div>
  );
}